// ----------------------------------------------------------------------------
// Snippet: Newsletter Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/icon/icon';

// Styles
import './_newsletter-form.scss';

// -------------------------------------
// Newsletter success scroll positioning
// -------------------------------------
var CUSTOMER_POSTED_QUERY = 'customer_posted';
var HEADER_OFFSET_PX = 250;
function scrollNewsletterSuccessIntoView() {
  var params = new URLSearchParams(window.location.search);
  if (params.get(CUSTOMER_POSTED_QUERY) !== 'true') {
    return;
  }
  var hash = window.location.hash.slice(1);
  var form = document.getElementById(hash);
  var root = form.closest('[data-newsletter-root]');
  root.querySelector('[data-newsletter-success]');
  var top = root.getBoundingClientRect().top + window.scrollY;
  window.scrollTo({
    top: Math.max(0, top - HEADER_OFFSET_PX),
    behavior: 'smooth'
  });
}
document.addEventListener('DOMContentLoaded', () => {
  requestAnimationFrame(() => {
    window.setTimeout(scrollNewsletterSuccessIntoView, 0);
  });
});